import { useNavigate } from 'react-router-dom'
import { CrmDataTable, crmTableHeadClass, crmTableRowClass } from '@/components/ui/CrmDataTable'
import type { ClienteAgradaRow } from '@/services/clientesService'

export function ClientesAgradaTable({ clientes }: { clientes: ClienteAgradaRow[] }) {
  const navigate = useNavigate()
  const headClass = crmTableHeadClass()

  return (
    <CrmDataTable>
      <table className='w-full text-sm'>
        <thead>
          <tr className={headClass}>
            <th className='px-4 py-3'>Cliente</th>
            <th className='px-4 py-3'>CNPJ</th>
            <th className='px-4 py-3'>Deal ganho</th>
            <th className='px-4 py-3'>Projetos</th>
          </tr>
        </thead>
        <tbody>
          {clientes.length === 0 ? (
            <tr>
              <td colSpan={4} className='px-4 py-10 text-center text-text-muted'>
                Nenhum cliente ativo encontrado.
              </td>
            </tr>
          ) : (
            clientes.map((c) => (
              <tr
                key={c.id}
                className={crmTableRowClass(false)}
                onClick={() => navigate(`/clientes/${c.id}`)}
              >
                <td className='px-4 py-3 font-medium'>{c.nome}</td>
                <td className='px-4 py-3 font-mono text-xs'>{c.cnpj ?? '—'}</td>
                <td className='px-4 py-3'>{c.clienteAtivos[0]?.deal?.nome ?? '—'}</td>
                <td className='px-4 py-3'>{c._count.financeProjects}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </CrmDataTable>
  )
}
